export const formatterForCurrency = (
  amount: number | string,
  prefix: string = 'IDR',
): string => {
  if (typeof amount === 'string') {
    const realAmount = amount;
    amount = amount.replace(/\D/g, '');

    if (realAmount.slice(-3) === '.00') {
      amount = parseInt(amount) / 100;
    }
  }

  if (typeof amount === 'number') {
    amount = amount.toString();
  }

  const modulus = amount.length % 3;
  let formattedAmount = amount.substring(0, modulus);
  const thousand = amount.substring(modulus).match(/\d{3}/gi);

  if (thousand) {
    const separator = modulus ? '.' : '';
    formattedAmount += separator + thousand.join('.');
  }

  return `${prefix} ${formattedAmount}`;
};

export const formatterForCurrencyWithSupText = (text: string) => {
  const normalText = text.slice(0, -3);
  const supText = text.slice(-3);

  return {
    normalText,
    supText,
  };
};

export const getCategoryName = (category: string) => {
  switch (category) {
    case 'apparels':
    case 'fashion':
    case 'apparel':
      return 'apparel';
    case 'lifestyles':
    case 'toys':
    case 'electronics-collectibles':
      return 'electronics-collectibles';
    case 'handbags':
    case 'luxury':
      return 'luxury';
    case 'all_category':
      return '';
    case 'madeindonesia':
      return 'madeindonesia';
    default:
      return 'sneakers';
  }
};

export const getSystemCategory = (category: string) => {
  switch (category) {
    case 'apparels':
    case 'fashion':
    case 'apparel':
      return 'apparels';
    case 'lifestyles':
    case 'lifestyle':
    case 'toys':
    case 'electronics-collectibles':
      return 'lifestyles';
    case 'handbags':
    case 'luxury':
      return 'handbags';
    case 'madeindonesia':
      return 'madeindonesia';
    default:
      return 'sneakers';
  }
};
